import React from "react";
import LegalLayout from "../components/LegalLayout";

const CookiesPage: React.FC = () => (
  <LegalLayout
    title="Cookies Notice"
    path="/cookies"
    description="How PABS uses cookies and similar technologies to operate, secure, and improve the service."
    intro="How PABS uses cookies and similar technologies to operate, secure, and measure the service."
  >
        <p>
          This page explains how PABS uses cookies and similar technologies. “Cookies” are small text files stored
          by your browser. “Similar technologies” can include local storage, pixels, and device identifiers.
        </p>

        <h2>How we use cookies</h2>
        <ul>
          <li>
            <strong>Essential</strong>: required for core site/app functionality and security.
          </li>
          <li>
            <strong>Preferences</strong>: to remember settings (where applicable).
          </li>
          <li>
            <strong>Security</strong>: to help prevent abuse and protect the service (for example, via reCAPTCHA).
          </li>
          <li>
            <strong>Analytics</strong>: to understand how visitors use this website — which pages are viewed, how
            people arrive, and roughly where they are — so we can improve it.
          </li>
        </ul>

        <h2>Analytics</h2>
        <p>
          This website uses <strong>Google Analytics</strong>, loaded through <strong>Google Tag Manager</strong>. When
          you visit, Google Analytics sets first-party cookies (named <code>_ga</code> and <code>_ga_&lt;ID&gt;</code>)
          that assign your browser a random identifier, which lets us count visits and see how pages are used. These
          cookies expire after up to two years.
        </p>
        <p>
          The information collected includes the pages you view, how you reached the site, your device and browser type,
          and an approximate location derived from your IP address. Google Analytics does not store the full IP address.
          We use this information only in aggregate, and we do not use it to identify you or for advertising.
        </p>
        <p>
          Google processes this information on our behalf; see{" "}
          <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noreferrer">
            how Google uses information from sites that use its services
          </a>
          .
        </p>

        <h2>Your choices</h2>
        <p>
          Most browsers let you control cookies through settings. You can also clear local storage from your browser.
          If you disable cookies, parts of the site or app may not work correctly.
        </p>
        <p>
          To opt out of Google Analytics on this and other websites, block or delete the <code>_ga</code> cookies in your
          browser settings, or install the{" "}
          <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer">
            Google Analytics opt-out browser add-on
          </a>
          . Opting out does not affect how the site works.
        </p>

        <h2>Third-party technologies</h2>
        <p>
          Some pages load third-party services for analytics and security. See <a href="/subprocessors">Subprocessors</a> for
          commonly used vendors.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about cookies and privacy: <a href="mailto:privacy@pabs.online">privacy@pabs.online</a>
        </p>

        <p className="legal-note">
          This page is provided for general informational purposes and may be updated from time to time.
        </p>
  </LegalLayout>
);

export default CookiesPage;
